<template>
  <div>
    <div v-if="loading" class="text-center bg-gray-200 p-4 rounded">
      <Loader />
    </div>

    <div v-else-if="channels.length" class="space-y-4">
      <ChannelLine
        v-for="line in channels"
        :key="line.uuid"
        :channel="line"
        @channel-edit="editChannel"
        @channel-delete="confirmDeleteChannel"
      />
    </div>

    <div v-else class="bg-gray-200 p-6 text-center rounded">No channels found.</div>

    <portal v-if="channel && isActionEdit" to="app-dialog">
      <ModalEdit :channel="channel" @closed="resetAction" />
    </portal>

    <portal v-if="channel && isActionDelete" to="app-dialog">
      <BaseDialogDelete
        danger
        :custom-classes="'max-w-md'"
        @closed="resetAction"
        @confirmed="doDeleteChannel"
      />
    </portal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import ModalEdit from '@/components/ProjectChannel/ModalEdit.vue';
import ChannelLine from './ChannelLine.vue';

const ACTION_EDIT = 'edit';
const ACTION_DELETE = 'delete';

export default {
  components: {
    ChannelLine,
    ModalEdit,
  },

  props: {
    loading: Boolean,
    channels: { type: Array, default: () => [] },
  },

  data: () => ({
    pending: false,
    action: null,
  }),

  computed: {
    ...mapGetters('ui/channels', ['channel']),

    isActionEdit() {
      return this.action === ACTION_EDIT;
    },

    isActionDelete() {
      return this.action === ACTION_DELETE;
    },
  },

  methods: {
    ...mapActions('ui/channels', {
      deleteChannel: 'destroy',
    }),

    ...mapMutations('ui/channels', ['setCurrent']),

    editChannel(channel) {
      this.setCurrent(channel.id);
      this.action = ACTION_EDIT;
    },

    confirmDeleteChannel(channel) {
      this.setCurrent(channel.id);
      this.action = ACTION_DELETE;
    },

    resetAction() {
      this.setCurrent(null);
      this.action = null;
    },

    async doDeleteChannel() {
      this.pending = true;

      try {
        const { channelId } = await this.deleteChannel({ channelId: this.channel.id });
        this.$emit('channel-deleted', channelId);
        this.resetAction();
      } catch (error) {
        //
      }

      this.pending = false;
    },
  },
};
</script>
